import React from 'react';

const Problems: React.FC = () => {
  return (
    <section id="problems" className="py-20 bg-gradient-to-b from-white to-beige-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <p className="font-en text-navy-600 text-sm tracking-widest mb-4 uppercase">Problems</p>
          <h2 className="font-noto text-3xl md:text-4xl font-bold text-navy-900 mb-6">
            あなたの負動産、こんな理由で<br className="md:hidden" />処分できずに困っていませんか？
          </h2>
          <p className="font-noto text-lg text-navy-700 max-w-3xl mx-auto">
            多くの方が直面する負動産処分の壁。これらの問題、実は法的アプローチで解決できます。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* 問題1: 農地・山林 */}
          <div className="bg-white p-8 rounded-lg border border-beige-200 hover:shadow-lg transition-all duration-300">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-beige-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-plant-line text-navy-700 text-2xl"></i>
              </div>
              <h3 className="font-noto text-xl font-bold text-navy-900 mb-2">農地・山林の処分</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「農業委員会の許可が必要で手続きが複雑」</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「買い手が見つからない」</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「境界が不明確で測量費用が高額」</p>
              </div>
            </div>
          </div>

          {/* 問題2: 空き家・古家 */}
          <div className="bg-white p-8 rounded-lg border border-beige-200 hover:shadow-lg transition-all duration-300">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-beige-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-home-4-line text-navy-700 text-2xl"></i>
              </div>
              <h3 className="font-noto text-xl font-bold text-navy-900 mb-2">空き家・古家</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「取り壊し費用が数百万円かかる」</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「建物の状態が悪すぎて売れない」</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「近隣に迷惑をかけている」</p>
              </div>
            </div>
          </div>

          {/* 問題3: 市街化調整区域 */}
          <div className="bg-white p-8 rounded-lg border border-beige-200 hover:shadow-lg transition-all duration-300">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-beige-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-road-map-line text-navy-700 text-2xl"></i>
              </div>
              <h3 className="font-noto text-xl font-bold text-navy-900 mb-2">市街化調整区域</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「建物が建てられない土地」</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「不動産会社に断られる」</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「固定資産税だけがかかり続ける」</p>
              </div>
            </div>
          </div>

          {/* 問題4: 共有不動産 */}
          <div className="bg-white p-8 rounded-lg border border-beige-200 hover:shadow-lg transition-all duration-300">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-beige-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-group-line text-navy-700 text-2xl"></i>
              </div>
              <h3 className="font-noto text-xl font-bold text-navy-900 mb-2">共有不動産</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「他の共有者の同意が得られない」</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「連絡が取れない共有者がいる」</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「持分だけでは処分できない」</p>
              </div>
            </div>
          </div>

          {/* 問題5: 借地・底地 */}
          <div className="bg-white p-8 rounded-lg border border-beige-200 hover:shadow-lg transition-all duration-300">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-beige-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-contract-line text-navy-700 text-2xl"></i>
              </div>
              <h3 className="font-noto text-xl font-bold text-navy-900 mb-2">借地・底地</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「借地権と底地権が複雑に絡み合っている」</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「地主と借地人の関係が悪化」</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「権利関係が複雑で売却困難」</p>
              </div>
            </div>
          </div>

          {/* 問題6: 国庫帰属の壁 */}
          <div className="bg-white p-8 rounded-lg border border-beige-200 hover:shadow-lg transition-all duration-300">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-beige-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-government-line text-navy-700 text-2xl"></i>
              </div>
              <h3 className="font-noto text-xl font-bold text-navy-900 mb-2">国庫帰属の壁</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「要件が厳しく承認されない」</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「負担金が高額で現実的でない」</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-close-circle-line text-red-500 text-lg mt-1"></i>
                <p className="font-noto text-navy-700 text-sm">「手続きが複雑で時間がかかる」</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problems;